<dialog-draggable-header class="padding-bottom">Batch Jobs</dialog-draggable-header>
<mat-dialog-content>
  <div class="flex-dialog-container">
    <div class="space-between-items pt-1">
      <span class="h4">Daily Jobs</span>
    </div>
    <div class="space-between-items pt-1">
      <div>
        <p class="font-size">Early warning reminder (Daily)</p>
      </div>
      <div>
        <button class="float-left" mat-raised-button color="primary" (click)="onDailyWarningProcessClick()">
          Run Job
        </button>
      </div>
    </div>
    <div class="space-between-items pt-1">
      <div>
        <p class="font-size">User Profile Update</p>
      </div>
      <div>
        <button class="float-left" mat-raised-button color="primary" (click)="onUserProfileUpdateProcessClick()">
          Run Job
        </button>
      </div>
    </div>
    <div class="space-between-items pt-1">
      <h4>Weekly Jobs</h4>
    </div>
    <div class="space-between-items pt-1">
      <div>
        <p class="font-size">Early warning reminder (Weekly)</p>
      </div>
      <div>
        <button class="float-left" mat-raised-button color="primary" (click)="onWeeklyWariningProcessClick()">
          Run Job
        </button>
      </div>
    </div>
    <div class="space-between-items pt-1">
      <div>
        <p class="font-size">TMACS Update</p>
      </div>
      <div>
        <button class="float-left" mat-raised-button color="primary" (click)="onTmacsProcessClick()">
          Run Job
        </button>
      </div>
    </div>
    <div class="space-between-items pt-1">
      <div>
        <p class="font-size">TPR Metric Reminder</p>
      </div>
      <div>
        <button class="float-left" mat-raised-button color="primary" (click)="onTprMetricProcessClick()">
          Run Job
        </button>
      </div>
    </div>
    <div class="space-between-items pt-1">
      <h4>Yearly Jobs</h4>
    </div>
    <div class="space-between-items pt-1">
      <div>
        <p class="font-size">ADM001/Trash File Cleanup</p>
      </div>
      <div>
        <button class="float-left" mat-raised-button color="primary" (click)="onQuoteAutoDeleteProcessClick()">
          Run Job
        </button>
      </div>
    </div>
    <div class="space-between-items pt-1">
      <div>
        <p class="font-size">PRD040 File Cleanup</p>
      </div>
      <div>
        <button class="float-left" mat-raised-button color="primary" (click)="onProdFileAutoDeleteProcessClick()">
          Run Job
        </button>
      </div>
    </div>
  </div>
</mat-dialog-content>
<div>
  <div mat-dialog-actions class="mat-dialog-actions-end no-margin">
    <button mat-raised-button mat-dialog-close>Close</button>
  </div>
</div>